<template>
    <div class="clearfix">
        <compFormEdit
            ref="form"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
            :col="1"
        ></compFormEdit>
        <compWrapper title="操作历史" theme="gray" v-if="querytype=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper>
        <div class="margin-15 pull-right" v-if="querytype!='query'">
            <Button class="margin-right-15" type="primary" @click="submit">{{
                $t("global.common.save", { defaultValue: "保存" })
            }}</Button>
            <Button type="default" @click="$emit('on-close')">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpHostAndCustomerWarehouse,
} from "@/service/carrieraccount.js";
import {
    HttpLimitOrgQuery,
    HttpSaveLimitOrg,
    HttpGetShipCarrier
} from "@/service/setting.js";

export default {
    props: ["activeid", "querytype"],
    data() {
        return {
            loading: false,
            formData: {},
            carrierGroupList: [],
            warehouseList: [],
            carrierServiceList: [],
            logList:[],
        };
    },
    created() {
        if (this.querytype !== "add") {
            this.getDetail();
        }
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            "getSelfmanageorgList",
        ]),
        getBase() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    key: "organizationId",
                    tag: "vSelect",
                    options: this.getSelfmanageorgList,
                    on:{
                        'on-change':(val)=>{
                            this.changeWarehouse(val)
                            this.getCarrierList(val)
                        }
                    },
                    props: {
                        filterable: true,
                    },
                    required: true,
                    query:this.querytype!='add',
                },
                {
                    label: this.$t("global.common.warehouse", {
                        defaultValue: "仓库",
                    }),
                    key: "orgWarehouseId",
                    tag: "vSelect",
                    options: this.warehouseList,
                    props: {
                        filterable: true,
                    },
                    required: true,
                    query:this.querytype!='add',
                    valueText:this.formData.orgWarehouseCode
                },
                {
                    label: this.$t("erp.product_channel.type", {
                        defaultValue: "类型",
                    }),
                    key: "type",
                    tag: "vSelect",
                    options: [
                        {value:'0',label:'快递'},
                        {value:'1',label:'卡车'}
                    ],
                    on:{
                        'on-change':(val)=>{
                            this.getCarrierList(val)
                        }
                    },
                    props: {
                        filterable: true,
                    },
                    query:this.querytype!='add',
                    required: true,
                },
                {
                    label: this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
                    key: "carrierId",
                    tag: "vSelect",
                    options: this.carrierGroupList,
                    query:this.querytype!='add',
                    valueText:this.formData.carrierCode
                },
                {
                    label: this.$t('fbb.alloment.date', { defaultValue: "日期" }),
                    tag: 'vDatepicker',
                    key: 'date',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    query:this.querytype!='add',
                    valueText:this.formData.capacityDate
                },
                {
                    label: this.$t('', { defaultValue: '限额' }),
                    tag:'vInputNumber',
                    key:'capacity',
                    props:{
                        min:0
                    },
                    on:{
                        'on-blur':(val)=>{
                            this.formData.capacity = Math.round(val)
                        }
                    },
                    query:this.querytype=='query',
                }
            ];
        },
    },
    methods: {
        changeWarehouse(organizationId){
            HttpHostAndCustomerWarehouse({
                    contextId: global.SYSID,
                    orgId: organizationId,
                }).then(
                    (res) => {
                        this.warehouseList = res.data.map((item) => {
                            return {
                                value: item.id,
                                label: `${item.code}(${item.title})`,
                                attach: {
                                    ...item,
                                },
                            };
                        });
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
        },
        getCarrierList(val){
            if(this.formData.organizationId && this.formData.type){
                HttpGetShipCarrier({
                    customerId:this.formData.organizationId,
                    type:this.formData.type
                }).then(res=>{
                    // console.log(res)
                    this.carrierGroupList = res.data.map(item=>{
                        return {
                            value:item.id,
                            label:item.carrierGroupCode
                        }
                    })
                },err=>{
    
                })
            }else{
                this.carrierGroupList = []
            }
        },
        async getDetail() {
            this.loading = true;
            await HttpLimitOrgQuery({
                id: this.activeid,
            }).then(
                (res) => {
                    this.formData = res.data;
                    this.logList = res.data.orderLogs
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        async submit() {
            let flag = await this.$refs.form.validate();
            if (!flag) return;

            if(this.querytype == 'add'){
                this.formData.startDate = this.formData.date.split('~')[0]
                this.formData.endDate = this.formData.date.split('~')[1]
                delete this.formData.date
            }
            await HttpSaveLimitOrg({
                id: this.activeid,
                ...this.formData,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                    this.$emit("on-close");
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
    },
};
</script>

